<template>
  <div class='auth' v-loading.fullscreen.lock="loading">
    <!--
    <div class="logo"></div>
    -->
    <div class="triangle">
      <transition name="fade">
        <div class="triangle_1" v-show="index >= 1"></div>
      </transition>
      <transition name="fade">
        <div class="triangle_2" v-show="index >= 2"></div>
      </transition>
      <transition name="fade">
        <div class="triangle_3" v-show="index >= 3"></div>
      </transition>
      <transition name="fade">
        <div class="triangle_4" v-show="index >= 4"></div>
      </transition>
      <transition name="fade">
        <div class="triangle_5" v-show="index >= 5"></div>
      </transition>
    </div>
    <div class="text"></div>
    <div class="ball_1"></div>
    <div class="ball_2"></div>
    <div class="ball_3"></div>
    <div class="From">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="UserName">
          <div class="userIcon"></div>
          <div class="userBox">
            <el-input v-model.trim="ruleForm.UserName" placeholder='请输入用户账号'></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="PassWord">
          <div class="passwordIcon"></div>
          <div class="passwordBox">
            <el-input type="password" v-model.trim="ruleForm.PassWord" placeholder='请输入用户密码' show-password></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="Botton">
            <el-button class="Botton_main" type="primary" @click="Loding" round>登录</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="ForgetPassword"><span>忘记密码</span></div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/auth'
export default {
  name: 'auth',

  data () {
    return {
      index: 0,
      loading: false,
      ruleForm: {
        UserName: '',
        PassWord: ''
      },
      rules: {
        UserName: [
          { required: true, message: '请输入用户账号', trigger: 'blur' }
        ],
        PassWord: [
          { required: true, message: '请输入用户密码', trigger: 'blur' }
        ]
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.Timer()
    },

    Timer () {
      setInterval(() => {
        this.index++
        if (this.index > 7) {
          this.index = 0
        }
      }, 1000)
    },

    Loding () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.getData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    getData () {
      const params = {
        method: api.login,
        username: this.ruleForm.UserName,
        password: this.ruleForm.PassWord
      }

      this.loading = true
      this.axios.post(params).then(res => {
        this.loading = false
        if (res.data.backend_org_ums_user_login_response.code !== '10000') return
        sessionStorage.setItem('token', `${res.data.backend_org_ums_user_login_response.tokenHead}${res.data.backend_org_ums_user_login_response.token}`)
        this.UserInfo()
      })
    },

    UserInfo () {
      const params = {
        method: api.userInfo
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_org_ums_userInfo_get_response.code !== '10000') return
        sessionStorage.setItem('User', JSON.stringify(res.data.backend_org_ums_userInfo_get_response))
        this.$router.push({ name: 'BILLREQUEST' })
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
  .auth
    height 100%
    background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/background.png') no-repeat center/100% 100%
    position relative
    overflow hidden
    .logo
      width 155px
      height 43px
      position absolute
      top 55px
      left 73px
      background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/logo.png') no-repeat center/contain
    .triangle
      width 550px
      height 532px
      position absolute
      top 0
      left 373px
      background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/dian.png') no-repeat center/contain
      .triangle_1
        width 43px
        height 69px
        position absolute
        top 187px
        left 358px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/triangle-5.png') no-repeat center/contain
      .triangle_2
        width 58px
        height 93px
        position absolute
        top 175px
        left 330px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/triangle-4.png') no-repeat center/contain
      .triangle_3
        width 87px
        height 138px
        position absolute
        top 156px
        left 280px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/triangle-3.png') no-repeat center/contain
      .triangle_4
        width 114px
        height 182px
        position absolute
        top 139px
        left 237px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/triangle-2.png') no-repeat center/contain
      .triangle_5
        width 145px
        height 231px
        position absolute
        top 118px
        left 191px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/triangle-1.png') no-repeat center/contain
    .text
      width 470px
      height 147px
      position absolute
      top 156px
      left 798px
      background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/text.png') no-repeat center/contain
    .ball_1
      width 473px
      height 461px
      position absolute
      bottom 79px
      left 1357px
      background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/ball-1.png') no-repeat center/contain
      animation myfirst 120s
      animation-iteration-count infinite
      animation-timing-function linear
      @keyframes myfirst
        0%
          transform rotateZ(0deg)
        100%
          transform rotateZ(360deg)
    .ball_2
      width 421px
      height 410px
      position absolute
      bottom 105px
      left 1383px
      background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/ball-2.png') no-repeat center/contain
      animation myfirst2 60s
      animation-iteration-count infinite
      animation-timing-function linear
      @keyframes myfirst2
        0%
          transform rotateZ(360deg)
        100%
          transform rotateZ(0deg)
    .ball_3
      width 540px
      height 560px
      position absolute
      bottom 29px
      left 1306px
      background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/ball-3.png') no-repeat center/contain
      animation myfirst3 120s
      animation-iteration-count infinite
      animation-timing-function linear
      @keyframes myfirst3
        0%
          transform rotateZ(360deg)
        100%
          transform rotateZ(0deg)
    .From
      position absolute
      top 407px
      left 743px
      .userIcon
        width 43px
        height 43px
        background red
        float left
        margin-right 10px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/icon-2.png') no-repeat center/contain
      .userBox
        width 293px
        float left
      .passwordIcon
        width 43px
        height 43px
        background red
        float left
        margin-right 10px
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/icon-1.png') no-repeat center/contain
      .passwordBox
        width 293px
        float left
      .Botton
        width 397px
        height 96px
        margin-top -20px
        position relative
        background url('https://aquilafly-website.oss-cn-shenzhen.aliyuncs.com/assets/login/button.png') no-repeat center/contain
        .Botton_main
          position absolute
          top 20px
          width 289px
          height 45px
          left 54px
          background linear-gradient(to left, #188AFF , #3CA6FF)
          border none
          font-size 20px
          letter-spacing 6px
      .ForgetPassword
        font-size 18px
        line-height 18px
        color #ffffff
        text-align center
        margin-top -20px
        span
          cursor pointer
</style>

<style lang="stylus">
  .auth
    .el-form-item__error
      text-indent 53px!important
</style>
